///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item = abcsetup.rx_item || {};
abcsetup.rx_item.workflow = abcsetup.rx_item.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.task = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item.workflow = {
    init: function () {
        $("html, body").scrollTop(0);
        abcsetup.setTitle('Edit RxItem');

        // Assign local vars
        abcsetup.item = JSON.parse($('form.rx-item #item_object').html());
        abcsetup.task = JSON.parse($('form.rx-item #current_task').html());

        // Disable the approve button when rejecting
        $('#reject-btn-dropdown').on('shown.bs.dropdown', function () {
            $('div.right .buttons .btn-approve').attr('disabled', true);
        }).on('hidden.bs.dropdown', function () {
            $('div.right .buttons .btn-approve').attr('disabled', false);
        });

        // Item details accordion
        $("#nav-details .collapse").on('show.bs.collapse', function () {
            $(this).parent().parent().find('.collapse.show').collapse('hide');
        });

        // Set up default fields to help with showIf and requireIf behavior
        abcsetup.form_manager.form = $('form.rx-item');
        abcsetup.form_manager.setAndCreate();

        // Bind the reject dropdown events
        this._bindRejectDropdown();

        // Bind the search details input field
        this._bindDetailsSearch();

        // Init item history datatable
        abcsetup.datatables.client_side.init($('#item_history'), {
            'dom': 'x',
            'iDisplayLength': -1,
            'order': [[1, 'asc']],
            'responsive': false,
        });

        // Init the duplicate items datatable
        abcsetup.datatables.client_side.init($('#duplicate_table'), {
            'dom': 'x',
            'iDisplayLength': -1,
            'order': [[1, 'asc']],
            'responsive': false,
            //'ordering': false,
        });

        // Apply slim scroll
        var height = $(window).height() - $('div.tab-content').offset().top - 30;
        if (height < 300) {
            height = 300;
        }

        $('div.right div.tab-content').slimScroll({
            height: height,
            position: 'right',
            railVisible: true,
            alwaysVisible: true
        });

        // Check for duplicates
        if ($('#duplicate_check').length) {
            this._checkForDuplicates();

            /**
             * Handle identifier changes and warn about duplicate items
             */

            $(".article_identifier").on('keyup', function() {
                $('div.right .buttons .btn-approve').attr('data-duplicate-check',"true");
            });

            $('div.right .buttons .btn-approve').on('click', function() {
                if ($('div.right .buttons .btn-approve').hasClass('loading')) {
                    return false;
                }
                if ($('div.right .buttons .btn-approve').attr('data-duplicate-check') == "true") {
                    abcsetup.rx_item.workflow._checkForDuplicatesBeforeSubmit();
                    return false;
                }
            });
        }

        // Reject button clicked
        $('#reject-btn').on('click', function () {
            abcsetup.rx_item.workflow._rejectItem();
        });

        $(document).on('click', '#accept-reassign', function (e) {
            abcsetup.blockUI(true);
        });

        // Validate each visible required field
        $('.btn-validator').on('click', function () {
            var isValid = true;

            $(this).closest('form').find(':input:visible').each(function () {
                console.log('field: ' + $(this).attr('name'));
                // $(this)[0].validate();
                // console.log('rules: ',$(this).rules());
                if (!$(this)[0].checkValidity()) {
                    isValid = false;
                }

                // TODO: Run the validations via fieldValidate?
                //window.fieldValidate.runValidations(this);
                //if (!this.validity.valid) {
                //isValid = false;
                //}
            });

            if (isValid) {
                abcsetup.alerts.show('Form Validation', 'All fields on this tab have passed validation');
            } else {
                $('.invalid:visible:first').trigger('focus');
                abcsetup.alerts.show('Form Validation', 'There are errors on this tab. Please review the fields highlighted in red');
            }
        });

        /**
         * Handles changing button text on collapse duplicate items table
         */

         $("body").on('show.bs.collapse', function(e) {
            if (e.target.id == "duplicateItems") {
                $('#duplicateItemsCollapseButton').text('Collapse Table');
            }
        });

        $("body").on('hide.bs.collapse', function(e) {
            if (e.target.id == "duplicateItems") {
                $('#duplicateItemsCollapseButton').text('Expand Table');
            }
        });

        $('form.rx-item input, form.rx-item select').on('keypress', function(e){
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        });

        $(document).on('change', '#product_regulated_cfr', function() {
            if ($(this).val() == 'N' || $(this).val() == '') {
                $('#hazmat_id_cfr').val('');
                $('#un_id_cfr').val('');
                $('#hazard_class_cfr').val('');
                $('#pack_group_cfr').val('');
                $('#shipping_name_1_cfr').val('');
                $('#label_code_cfr').val('');
                $('#qty_limit_par_cfr').val('');
                $('#qty_limit_cao_cfr').val('');
                $('#vessel_stowage_location_cfr').val('');
                $('#vessel_stowage_other_cfr').val('');
            }
        });
    },

    /**
     * _jquery.fieldLib hase been init - this is the callback
     */
    fieldsInit: function () {
        // Init any field restrictions/values
        this._initFields();

        // Init the GTIN Grid
        this._initGTIN();

        // Init the SAP Div
        this._initSAPDiv();
    },

    /**
     * Bind the reject dropdown events
     */
    _bindRejectDropdown: function () {
        $('.dropdown-menu.reject input.checkbox').prop('checked', false);

        $(document).on('click', '.dropdown-menu.reject', function (event) {
            event.stopPropagation();
        });

        $(document).on('click', '.dropdown-menu.reject input.checkbox', function () {
            if ($(this).prop('checked')) {
                $(this).closest('div.checkbox').find('textarea').show();
            } else {
                $(this).closest('div.checkbox').find('textarea').hide().next('.errorMsg').remove();
            }
        });
    },


    /**
     * Bind the search details input field
     */
    _bindDetailsSearch: function () {
        // The search field had a key pressed
        $("#nav-details").find("#details-search").on("keyup", function (e) {
            var code = e.which;
            var value = $(this).val().toLowerCase();

            if (value) {
                // Filter down the sections to what was typed
                $("#nav-details .item-details, #nav-details .item-details h5").filter(function () {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                });

                $("#nav-details .item-details:visible").find('.collapse').addClass('show');
                $("#nav-details .item-details h5").unhighlight().highlight(value);

            } else {
                // Clear search results and show all
                $("#nav-details .item-details, #nav-details .item-details h5").show();
                $("#nav-details .item-details:visible").find('.collapse').removeClass('show');
                $("#nav-details .item-details h5").unhighlight();
            }
        });

        // Expand/Collapse All
        $("#nav-details").find("#toggle_all").on("click", function (e) {
            $(this).blur().parent().parent().find('.collapse').collapse('toggle');
        });
    },

     /**
     * Check for duplicates
     */
      _checkForDuplicates: function () {
        var approve_btn = $('div.right .buttons .btn-approve');
        approve_btn.attr('disabled', true);

        axios.get('/api/rx_item/duplicate_check/' + abcsetup.item.id).then(response => {
            approve_btn.attr('disabled', false);
            //alert(JSON.stringify(response.data.existing_item_record.length));

            if (response.data.error) {

                $("#duplicate_check")
                    .removeClass('alert-warning')
                    .addClass('alert-danger')
                    .html('Error querying Enterprise database');

            } else if (response.data.existing_item_record.length) {
                let duplicateItemsExistText = $('#duplicateItemsExistText');
                let ignoreEmdmDuplicates = $('#ignoreEmdmDuplicates');
                let duplicateItemsTable = $('#duplicateItems');
                let duplicateItemTbody = $('#duplicateItemsTableBody');
                let duplicateItemsCollapseButton = $('#duplicateItemsCollapseButton');

                $(response.data.existing_item_record).each(function () {
                    duplicateItemTbody.append(
                        '<tr>' +
                            '<td>' + (this.emat_id ? this.emat_id : '') + '</td>' +
                            '<td>' + (this.sap_num ? this.sap_num : '') + '</td>' +
                            '<td>' + (this.mat_status ? this.mat_status : '') + '</td>' +
                            '<td>' + (this.mat_type ? this.mat_type : '') + '</td>' +
                            '<td>' + (this.mat_group ? this.mat_group : '') + '</td>' +
                            '<td>' + (this.mat_descr ? this.mat_descr : '') + '</td>' +
                        '</tr>'
                    );
                });

                $("#duplicate_check").addClass('d-none'); //Hide loader
                //Display all table elements
                duplicateItemsExistText.removeClass('d-none');
                ignoreEmdmDuplicates.removeClass('d-none');
                duplicateItemsCollapseButton.removeClass('d-none');
                duplicateItemsTable.removeClass('d-none');
                approve_btn.attr('disabled', false);
                approve_btn.append('<i class="fas fa-exclamation-circle text-caution ml-2"></i>');
                approve_btn.attr('title', 'Click to Approve item with duplicate identifiers').tooltip();

            } else {
                 approve_btn.attr('data-duplicate-check',"true");
                 approve_btn.attr('disabled', false);
                $('#duplicate_check').removeClass('alert-warning').addClass('alert-success').html('No duplicate items were found in the Enterprise database.');
            }
        });
    },

    /**
     * Check for duplicates before submitting
     */
    _checkForDuplicatesBeforeSubmit: function () {
        var approve_btn = $('div.right .buttons .btn-approve');
        approve_btn.attr('disabled', true);

        var article_identifiers = {};
        $("input.article_identifier").each(function() {
            var field_name = $(this).attr("name");
            if (field_name && typeof field_name === "string" && $(this).val()) {
                article_identifiers[field_name] = $(this).val();
            }
        });
        console.log("article_identifiers: "+JSON.stringify(article_identifiers,{},4));

        $('#duplicate_check').removeClass().addClass('alert alert-neutral col-12').html('<i class="fas fa-spinner fa-spin"></i> Checking for duplicate items in the Enterprise database...');
        $("#duplicate_check").removeClass('d-none'); //Show loader
        //Hide all table elements
        $('#duplicateItemsExistText').addClass('d-none');
        $('#ignoreEmdmDuplicates').addClass('d-none');
        $('#duplicateItemsCollapseButton').addClass('d-none');
        $('#duplicateItems').addClass('d-none');
        $('#duplicateItemsTableBody').html('');

        approve_btn.html('Approve');

        axios.get('/api/rx_item/duplicate_check/' + abcsetup.item.id, { params: {query_identifiers: article_identifiers} }).then(response => {
            approve_btn.attr('disabled', false);
            //alert(JSON.stringify(response.data.existing_item_record.length));

            if (response.data.error) {

                $("#duplicate_check")
                    .removeClass('alert-warning')
                    .addClass('alert-danger')
                    .html('Error querying Enterprise database');

            } else if (response.data.existing_item_record.length) {
                let duplicateItemsExistText = $('#duplicateItemsExistText');
                let ignoreEmdmDuplicates = $('#ignoreEmdmDuplicates');
                let duplicateItemsTable = $('#duplicateItems');
                let duplicateItemTbody = $('#duplicateItemsTableBody');
                let duplicateItemsCollapseButton = $('#duplicateItemsCollapseButton');

                $(response.data.existing_item_record).each(function () {
                    duplicateItemTbody.append(
                        '<tr>' +
                            '<td>' + (this.emat_id ? this.emat_id : '') + '</td>' +
                            '<td>' + (this.sap_num ? this.sap_num : '') + '</td>' +
                            '<td>' + (this.mat_status ? this.mat_status : '') + '</td>' +
                            '<td>' + (this.mat_type ? this.mat_type : '') + '</td>' +
                            '<td>' + (this.mat_group ? this.mat_group : '') + '</td>' +
                            '<td>' + (this.mat_descr ? this.mat_descr : '') + '</td>' +
                        '</tr>'
                    );
                });

                $("#duplicate_check").addClass('d-none'); //Hide loader
                //Display all table elements
                duplicateItemsExistText.removeClass('d-none');
                ignoreEmdmDuplicates.removeClass('d-none');
                duplicateItemsCollapseButton.removeClass('d-none');
                duplicateItemsTable.removeClass('d-none');
                approve_btn.attr('data-duplicate-check',"false");
                approve_btn.append('<i class="fas fa-exclamation-circle text-caution ml-2"></i>');
                approve_btn.attr('title', 'Click to Approve item with duplicate identifiers').tooltip();

            } else {
                $('#duplicate_check').removeClass('alert-warning').addClass('alert-success').html('No duplicate items were found in the Enterprise database.')
                approve_btn.attr('data-duplicate-check',false).trigger('click');
            }
        });
    },


    /**
     * Init any field restrictions/values
     */
    _initFields: function () {
        // if (abcsetup.item.role.role_class.id == 'oncology_cm') {
        //     $('#mpi').val('05');
        // }

        const init_class = abcsetup.item && abcsetup.item.role ? abcsetup.item.role.class : '';

        if (abcsetup.userRole.class === 'grx_analyst') {
            $('#mat_group').val("GRX");
        }

        if (abcsetup.userRole.class === 'gsmd_team') {
            if ($('#application').val() === 'BLA') {
                $('#mat_group').val("BRX").attr('readonly', true);
            }
        }

        $("#listed_chemical").change(function() {
            if ($(this).val() != 'Y') {
                $("#chemical").val('').after('<input type="hidden" id="chemical" name="chemical" class="hidden_listed_chemical" value="">');
                $("#chemical_other").val('').after('<input type="hidden" id="chemical_other" name="chemical_other" class="hidden_listed_chemical" value="">');
                $("#chemical_ingredient_amount").val('').after('<input type="hidden" id="chemical_ingredient_amount" name="chemical_ingredient_amount" class="hidden_listed_chemical" value="">');
                $("#chemical_ingredient_uom").val('').after('<input type="hidden" id="chemical_ingredient_uom" name="chemical_ingredient_uom" class="hidden_listed_chemical" value="">');
                $("#chemical_category").val('').after('<input type="hidden" id="chemical_category" name="chemical_category" class="hidden_listed_chemical" value="">');
            }
            else {
                $(".hidden_listed_chemical").remove();
            }
        }).trigger("change");

        if ($("#type").val() === 'otg') {
            //disabled 12/19/2022 upon lindsays request for ticket abcs-1235 -ke
            /* $('#mat_group').val('OTG');
            $('#mat_group').attr('disabled', true).addClass('readonly');
            $('#mat_group').after('<input type="hidden" id="mat_group" name="mat_group" value="OTG">'); */
        }

        // Check if the user or item role is specialy and not ahp_cm - and set shipment_info to drop_ship
        if ((abcsetup.userRole.role_class.specialty === 1 && abcsetup.userRole.class !== 'ahp_cm') ||
            (abcsetup.item.role.role_class.specialty === 1 && abcsetup.item.role.role_class.id !== 'ahp_cm')) {
            $('#shipment_info').val('drop_ship').trigger("change");
            if ($('#shipment_info:visible').length) {
                abcsetup.fieldLib._readOnlyField($('#shipment_info'), true);
                $('.field-value.shipment_info .value').html('Drop-Ship Only')
            }
        }

        // Check if the user or item role is specialy and ahp_cm - and set shipment_info to direct-ship only
        if (abcsetup.item.role.role_class.id == 'ahp_cm') {
            $('#shipment_info').val('direct_ship').trigger("change");
            if ($('#shipment_info:visible').length) {
                abcsetup.fieldLib._readOnlyField($('#shipment_info'), true);
                $('.field-value.shipment_info .value').html('Direct-Ship Only')
            }
        }

        // Transmit info changed
        $(document).on('change', '#transmit_uom_inner', function (e) {
            if ($('#transmit_uom_inner').val() === 'N') {
                $('#transmit_uom_case').val('Y');
            }
        });

        $(document).on('change', '#transmit_uom_case', function (e) {
            if ($('#transmit_uom_case').val() === 'N') {
                $('#transmit_uom_inner').val('Y');
            }
        });

        // mat_descr + abbr_descr maxlength check
        $('#mat_descr, #abbr_descr').on('keyup', function () {
            $(this).parent().find('.maxlength').remove();
            var charLeft = $(this).attr('maxlength') - $(this).val().length;
            if (charLeft == 0) {
                $(this).after('<div class="note text-muted maxlength custom-error">You\'ve reached the maximum character limit</div>');
            }
        }).on('blur', function () {
            $(this).parent().find('.maxlength').remove();
        });

        // event handler for UoM ndc10_format select lists
        $.each(['selling_unit', 'individual_unit', 'unit_dose'], function () {
            var uom = this;

            $("input[name='" + uom + "_ndc10']").change(function () {
                var ndc10 = $(this).val();
                var ndc10_format = $("select[name='" + uom + "_ndc10_format']").val();
                var ndc11 = $("input[name='" + uom + "_ndc']");

                if (ndc10.length) {
                    switch (ndc10_format) {
                        case "4-4-2":
                            var str = "0" + ndc10.replace(/\-/g, "");
                            ndc11.val(str);
                            break;
                        case "5-3-2":
                            var str = ndc10.substr(0, 5) + "0" + ndc10.substr(6, 3) + ndc10.substr(10, 2);
                            ndc11.val(str);
                            break;
                        case "5-4-1":
                            var str = ndc10.substr(0, 5) + ndc10.substr(6, 4) + "0" + ndc10.substr(11, 1);
                            ndc11.val(str);
                            break;
                    }
                } else {
                    //                if (abcsetup.item.role.class != 'field_team') {
                    //                   ndc11.val("").trigger("change");
                    //                }
                }

            }).trigger("change");

            $("input[name='" + uom + "_ndc']").change(function () {
                var ndc11 = $(this).val();
                var ndc10_format = $("select[name='" + uom + "_ndc10_format']");
                var ndc10 = $("input[name='" + uom + "_ndc10']");

                if (ndc11.length) {
                    if (abcsetup.item.role.class === 'field_team') {
                        if (uom === 'selling_unit') {
                            if (ndc11.length == 11) {
                                ndc10_format.siblings(".input_required_indicator").hide();
                                //ndc10_format.rules('remove','required');
                            } else {
                                ndc10_format.siblings(".input_required_indicator").show();
                            }
                        }
                    }

                    switch (ndc10_format.val()) {
                        case "4-4-2":
                            var str = ndc11.substr(1, 4) + "-" + ndc11.substr(5, 4) + "-" + ndc11.substr(9, 2);
                            ndc10.val(str);
                            break;
                        case "5-3-2":
                            var str = ndc11.substr(0, 5) + "-" + ndc11.substr(6, 3) + "-" + ndc11.substr(9, 2);
                            ndc10.val(str);
                            break;
                        case "5-4-1":
                            var str = ndc11.substr(0, 5) + "-" + ndc11.substr(5, 4) + "-" + ndc11.substr(10, 1);
                            ndc10.val(str);
                            break;
                    }
                } else {
                    if (abcsetup.item.role.class === 'field_team') {
                        ndc10_format.siblings(".input_required_indicator").show();
                    }
                }

            }).trigger("change");

            $("select[name='genitemcatgroup']").change(function () {
                if ($(this).val() == "ZFRE") {
                    $("input[name='nrfhg']").val("4").attr("readonly", true);
                } else {
                    $("input[name='nrfhg']").val("").attr("readonly", true);
                }
            }).trigger("change");

        });

        $("#dscsa_exempt").change(function () {
            var dscsa_exempt = $(this).val();
            var dup_item = abcsetup.item.sap_item_number;
            var short_dated_prod = abcsetup.item.short_dated_prod;

            if ((dup_item == '' && short_dated_prod != 'Y') || (dup_item != '' && short_dated_prod != 'Y')) {
                if (dscsa_exempt === 'N') {
                    $('.enable_gtin_level').each(function () {
                        if ($(this).val() === 'item' || $(this).val() === 'case') {
                            $(this).prop("checked", true);
                            $(this).trigger("change");
                            $(this).attr("disabled", true);
                        }
                    });
                } else {
                    $('.enable_gtin_level').each(function () {
                        if ($(this).val() === 'item' || $(this).val() === 'case') {
                            if ($(this).is(":disabled")) {
                                $(this).attr("disabled", false);
                                $(this).prop("checked", false);
                            }
                            $(this).trigger("change");
                        }
                    });
                }
            }

            if (dscsa_exempt == 'WEE') {
                $("#dscsa_exempt_reason").val("18").attr('disabled',true).addClass('readonly');
                $("#dscsa_exempt_reason").after('<input type="hidden" id="dscsa_exempt_reason" name="dscsa_exempt_reason" value="18">');
                $("#serialized").val("Y").attr('disabled',true).addClass('readonly');
                $("#serialized").after('<input type="hidden" id="serialized" name="serialized" value="Y">');
            }
            else {
                if ($("#dscsa_exempt_reason").val() == '18') {
                    $("#dscsa_exempt_reason").val("").attr('disabled',false).removeClass('readonly');
                    $("input[id='dscsa_exempt_reason']").remove();
                }
                $("#serialized").val("").attr('disabled',false).removeClass('readonly');
                $("input[id='serialized']").remove();
            }
        }).trigger("change");


        $("#item_pieces").change(function () {
            var item_pieces = $(this).val();
            $('.enable_gtin_level').each(function () {
                var enabled = $(this).is(':checked');
                if ($(this).val() === 'item') {
                    if (!enabled) {
                        return;
                    } else {
                        $("input[name='gtin_items[item][qty]']").val(item_pieces);
                        if (item_pieces != '') {
                            $("input[name='gtin_items[item][qty]']").attr("readonly", true).addClass("readonly");
                        } else {
                            $("input[name='gtin_items[item][qty]']").attr("readonly", false).removeClass("readonly");
                        }
                    }
                }
            });

            var pack_pieces = $("#pack_pieces").val();
            var pieces_check = Math.round((pack_pieces / item_pieces) * 100.0) / 100.0;

            if (pieces_check % 1 == 0) {
                $("#item_pieces").siblings(".form_error").remove();
                $("#item_pieces").removeClass("form_error");
            }
        });

        if ($("input[name='gtin_items[item][qty]']").val() == $("#item_pieces").val()) {
            $("#item_pieces").trigger("change");
        }

        $("#pack_pieces").change(function () {
            var pack_pieces = $(this).val();
            $('.enable_gtin_level').each(function () {
                var enabled = $(this).is(':checked');
                if ($(this).val() === 'inner') {
                    if (!enabled) {
                        return;
                    } else {
                        $("input[name='gtin_items[inner][qty]']").val(pack_pieces);
                        if (pack_pieces != '') {
                            $("input[name='gtin_items[inner][qty]']").attr("readonly", true).addClass("readonly");
                        } else {
                            $("input[name='gtin_items[inner][qty]']").attr("readonly", false).removeClass("readonly");
                        }
                    }
                }
            });

            var item_pieces = $("#item_pieces").val();
            var case_pieces = $("#case_pieces").val();
            var pieces_check = Math.round((pack_pieces / item_pieces) * 100.0) / 100.0;

            if (pieces_check % 1 == 0) {
                $("#pack_pieces").siblings(".form_error").remove();
                $("#pack_pieces").removeClass("form_error");
            }

            pieces_check = Math.round((case_pieces / pack_pieces) * 100.0) / 100.0;

            if (pieces_check % 1 == 0) {
                $("#pack_pieces").siblings(".form_error").remove();
                $("#pack_pieces").removeClass("form_error");
            }
        });

        if ($("input[name='gtin_items[inner][qty]']").val() == $("#pack_pieces").val()) {
            $("#pack_pieces").trigger("change");
        }

        $("#case_pieces").change(function () {
            var case_pieces = $(this).val();
            $('.enable_gtin_level').each(function () {
                var enabled = $(this).is(':checked');
                if ($(this).val() === 'case') {
                    if (!enabled) {
                        return;
                    } else {
                        $("input[name='gtin_items[case][qty]']").val(case_pieces);
                        if (case_pieces != '') {
                            $("input[name='gtin_items[case][qty]']").attr("readonly", true).addClass("readonly");
                        } else {
                            $("input[name='gtin_items[case][qty]']").attr("readonly", false).removeClass("readonly");
                        }
                    }
                }
            });

            var pack_pieces = $("#pack_pieces").val();
            var pallet_pieces = $("#pallet_pieces").val();
            var pieces_check = Math.round((case_pieces / pack_pieces) * 100.0) / 100.0;

            if (pieces_check % 1 == 0) {
                $("#case_pieces").siblings(".form_error").remove();
                $("#case_pieces").removeClass("form_error");
            }

            pieces_check = Math.round((pallet_pieces / case_pieces) * 100.0) / 100.0;

            if (pieces_check % 1 == 0) {
                $("#case_pieces").siblings(".form_error").remove();
                $("#case_pieces").removeClass("form_error");
            }
        });

        if ($("input[name='gtin_items[case][qty]']").val() == $("#case_pieces").val()) {
            $("#case_pieces").trigger("change");
        }

        $("#pallet_pieces").change(function () {
            var pallet_pieces = $(this).val();
            $('.enable_gtin_level').each(function () {
                var enabled = $(this).is(':checked');
                if ($(this).val() === 'pallet') {
                    if (!enabled) {
                        return;
                    } else {
                        $("input[name='gtin_items[pallet][qty]']").val(pallet_pieces);
                        if (pallet_pieces != '') {
                            $("input[name='gtin_items[pallet][qty]']").attr("readonly", true).addClass("readonly");
                        } else {
                            $("input[name='gtin_items[pallet][qty]']").attr("readonly", false).removeClass("readonly");
                        }
                    }
                }
            });

            var case_pieces = $("#case_pieces").val();
            var pieces_check = Math.round((pallet_pieces / case_pieces) * 100.0) / 100.0;

            if (pieces_check % 1 == 0) {
                $("#pallet_pieces").siblings(".form_error").remove();
                $("#pallet_pieces").removeClass("form_error");
            }
        });

        if ($("input[name='gtin_items[pallet][qty]']").val() == $("#pallet_pieces").val()) {
            $("#pallet_pieces").trigger("change");
        }

        $("#moq").change(function() {
            if ($(this).val() != "Y") {
                // Reset the MOQ fields
                $("#moq_ea").val("");
                $("#moq_ea").after('<input class="moq_ea_hidden" type="hidden" name="moq_ea" value="">');
                $("#moq_pk").val("");
                $("#moq_pk").after('<input class="moq_pk_hidden" type="hidden" name="moq_pk" value="">');
                $("#moq_cs").val("");
                $("#moq_cs").after('<input class="moq_cs_hidden" type="hidden" name="moq_cs" value="">');
            }
            else {
                $('.moq_ea_hidden').remove();
                $('.moq_pk_hidden').remove();
                $('.moq_cs_hidden').remove();
            }
        }).trigger("change");

        $("#blood_product").change(function() {
            var tmpID = abcsetup.randomString();
            var flu_product = $("#flu_product");
            var vac_product = $("#vaccine_product");
            var oral_med_product = $("#oral_med_product");

            if ($(this).val() == 'Y') {
                flu_product.val("N").attr('disabled',true).addClass('readonly');
                flu_product.after('<input type="hidden" id="' + flu_product.attr('id') + '" name="' + flu_product.attr('id') + '" value="N">');

                vac_product.val("N").attr('disabled',true).addClass('readonly');
                vac_product.after('<input type="hidden" id="' + vac_product.attr('id') + '" name="' + vac_product.attr('id') + '" value="N">');

                oral_med_product.val("N").attr('disabled',true).addClass('readonly');
                oral_med_product.after('<input type="hidden" id="' + oral_med_product.attr('id') + '" name="' + oral_med_product.attr('id') + '" value="N">');
            }
            else {
                if (flu_product.val() != 'Y' && vac_product.val() != 'Y' && oral_med_product.val() != 'Y') {
                    flu_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='flu_product']").remove();
                    vac_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='vaccine_product']").remove();
                    oral_med_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='oral_med_product']").remove();
                }
            }
        }).trigger("change");

        $("#flu_product").change(function() {
            var tmpID = abcsetup.randomString();
            var blood_product = $("#blood_product");
            var vac_product = $("#vaccine_product");
            var oral_med_product = $("#oral_med_product");

            if ($(this).val() == 'Y') {
                blood_product.val("N").attr('disabled',true).addClass('readonly');
                blood_product.after('<input type="hidden" id="' + blood_product.attr('id') + '" name="' + blood_product.attr('id') + '" value="N">');

                vac_product.val("N").attr('disabled',true).addClass('readonly');
                vac_product.after('<input type="hidden" id="' + vac_product.attr('id') + '" name="' + vac_product.attr('id') + '" value="N">');

                oral_med_product.val("N").attr('disabled',true).addClass('readonly');
                oral_med_product.after('<input type="hidden" id="' + oral_med_product.attr('id') + '" name="' + oral_med_product.attr('id') + '"value="N">');
            }
            else {
                if (blood_product.val() != 'Y' && vac_product.val() != 'Y' && oral_med_product.val() != 'Y') {
                    blood_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='blood_product']").remove();
                    vac_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='vaccine_product']").remove();
                    oral_med_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='oral_med_product']").remove();
                }
            }
        }).trigger("change");

        $("#vaccine_product").change(function() {
            var tmpID = abcsetup.randomString();
            var blood_product = $("#blood_product");
            var flu_product = $("#flu_product");
            var oral_med_product = $("#oral_med_product");
            var rx_group = $("#rx_group");

            if ($(this).val() == 'Y') {
                blood_product.val("N").attr('disabled',true).addClass('readonly');
                blood_product.after('<input type="hidden" id="' + blood_product.attr('id') + '" name="' + blood_product.attr('id') + '" value="N">');

                flu_product.val("N").attr('disabled',true).addClass('readonly');
                flu_product.after('<input type="hidden" id="' + flu_product.attr('id') + '" name="' + flu_product.attr('id') + '" value="N">');

                oral_med_product.val("N").attr('disabled',true).addClass('readonly');
                oral_med_product.after('<input type="hidden" id="' + oral_med_product.attr('id') + '" name="' + oral_med_product.attr('id') + '" value="N">');

                rx_group.val("03").attr("disabled",true).parent("td").addClass("readonly");
                rx_group.after('<input type="hidden" name="rx_group" value="03">');
            } else {
                rx_group.attr("disabled",false).parent("td").removeClass("readonly");
                $("input[name='rx_group']").remove();
                if (blood_product.val() != 'Y' && flu_product.val() != 'Y' && oral_med_product.val() != 'Y') {
                    blood_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='blood_product']").remove();
                    flu_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='flu_product']").remove();
                    oral_med_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='oral_med_product']").remove();
                }
            }
        }).trigger("change");

        $("#oral_med_product").change(function() {
            var tmpID = abcsetup.randomString();
            var blood_product = $("#blood_product");
            var flu_product = $("#flu_product");
            var vac_product = $("#vaccine_product");
            var product_type = $("#product_type");

            if ($(this).val() == 'Y') {
                blood_product.val("N").attr('disabled',true).addClass('readonly');
                blood_product.after('<input type="hidden" id="' + blood_product.attr('id') + '" name="' + blood_product.attr('id') + '" value="N">');

                flu_product.val("N").attr('disabled',true).addClass('readonly');
                flu_product.after('<input type="hidden" id="' + flu_product.attr('id') + '" name="' + flu_product.attr('id') + '" value="N">');

                vac_product.val("N").attr('disabled',true).addClass('readonly');
                vac_product.after('<input type="hidden" id="' + vac_product.attr('id') + '" name="' + vac_product.attr('id') + '" value="N">');

                //product_type.val("OMD");//.attr("disabled",true).parent("td").addClass("readonly");
            }
            else {
                if (blood_product.val() != 'Y' && flu_product.val() != 'Y' && vac_product.val() != 'Y') {
                    blood_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='blood_product']").remove();
                    vac_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='vaccine_product']").remove();
                    flu_product.attr('disabled',false).removeClass('readonly');
                    $("input[id='flu_product']").remove();
                }
            }
        }).trigger("change");

        $("#form").change(function() {
            var form_val = $(this).val();
            var oral_med_form = [
                "CAP",
                "CPL",
                "CHW",
                "CTB",
                "CRY",
                "ELX",
                "EXP",
                "GMY",
                "GCP",
                "GTB",
                "GRN",
                "GUM",
                "INH",
                "LCP",
                "LGL",
                "LOZ",
                "ORS",
                "PUD",
                "SYR",
                "SGC",
                "SGT",
                "TAB",
                "WAF"];

            if (oral_med_form.indexOf(form_val) > -1) {
                $("#oral_med_product").val("Y").trigger("change").addClass("readonly").attr('disabled',true);
                $("#oral_med_product").after('<input type="hidden" id="oral_med_product" name="oral_med_product" value="Y">');
            }
            else {
                $("#oral_med_product").val("").trigger("change").removeClass("readonly").attr('disabled',false);
                $("input[id='oral_med_product']").remove();
            }
        }).trigger("change");

        $(".product_type").change(function() {
            var product_type = $("#product_type");
            var prod_type_obj = {};

            if ($(this).val() == 'Y') {
               var type = $(this).attr("id");
               type_part = type.match(/(\w+)_product/)[1];
               console.log("abc_item/product_type: "+type_part);

                // Do not re-populate the Product Type select list if the 'injectable_product' question was changed
                // Values for Product Type are determined by the blood-,flu-,vaccine-,oral_med-, and med_surge-product questions
                if (type_part=='injectable') return;

                $.ajax({
                    type: "POST",
                    url: "/api/abc_item/product_type",
                    cache: false,
                    dataType: 'json',
                    data: {type: type_part},
                    success: function(result) {
                        console.log("abc_item/product_type->"+JSON.stringify(result,{},4));
                        // if (type_part != 'oral_med') {
                            product_type.empty().append($("<option></option>").attr("value","").text("-select-"));
                        // }
                        // else {
                        //     product_type.empty();
                        // }

                        if (!$.isEmptyObject(result)) {
                            prod_type_obj = result;
                            prod_type_obj.forEach(function(prod_type) {
                                product_type.append($("<option></option>").attr("value",prod_type.id).text(prod_type.name));
                            });

                            if (abcsetup.item != undefined) {
                                if (abcsetup.item && product_type.find("option[value='"+abcsetup.item.product_type+"']").length) {
                                    product_type.val(abcsetup.item.product_type);
                                }
                            }
                        }
                    }
                });
            }
        }).trigger("change");

        $.each(['item','pack','case','pallet'],function() {
            var uom = this;
            $("#"+uom+"_height").change(function(){
                if ($.isNumeric($(this).val()) && $.isNumeric($("#"+uom+"_width").val()) && $.isNumeric($("#"+uom+"_depth").val())) {
                    var volume = $(this).val() * $("#"+uom+"_width").val() * $("#"+uom+"_depth").val();
                    $("#"+uom+"_volume").val(Math.round(volume * 100) / 100);
                }
                else {
                    $("#"+uom+"_volume").val("");
                }
            }).trigger("change", {initialRun: true});
            $("#"+uom+"_width").change(function(){
                if ($.isNumeric($(this).val()) && $.isNumeric($("#"+uom+"_height").val()) && $.isNumeric($("#"+uom+"_depth").val())) {
                    var volume = $(this).val() * $("#"+uom+"_height").val() * $("#"+uom+"_depth").val();
                    $("#"+uom+"_volume").val(Math.round(volume * 100) / 100);
                }
                else {
                    $("#"+uom+"_volume").val("");
                }
            }).trigger("change", {initialRun: true});
            $("#"+uom+"_depth").change(function(){
                if ($.isNumeric($(this).val()) && $.isNumeric($("#"+uom+"_height").val()) && $.isNumeric($("#"+uom+"_width").val())) {
                    var volume = $(this).val() * $("#"+uom+"_height").val() * $("#"+uom+"_width").val();
                    $("#"+uom+"_volume").val(Math.round(volume * 100) / 100);
                }
                else {
                    $("#"+uom+"_volume").val("");
                }
            }).trigger("change", {initialRun: true});
        });

        /*
        * event handler for UoM ndc10_format select lists
        */
        $.each(['item', 'inner', 'case'], function () {
            var uom = this;
            $("select[name='" + uom + "_ndc10_format']").change(function () {
                var ndc10_format = $(this).val();
                var ndc10 = $("input[name='" + uom + "_ndc_10']");
                var ndc11 = $("input[name='" + uom + "_ndc']");

                if (ndc10_format && ndc10_format.length) {
                    if (ndc10.length && ndc10.val().length) {
                        var ndc11_val = "";
                        ndc11_val = abcsetup.rx_item.workflow.ndc10_to_ndc11(ndc10.val(), ndc10_format);
                        ndc11.val(ndc11_val);
                        console.log(uom + ': ndc10[' + ndc10.val() + ']->ndc11[' + ndc11_val + ']');
                    }
                }
            }).trigger("change");

            $("#" + uom + "_ndc_10").change(function () {
                var ndc10 = $(this).val();
                var ndc10_format = $("select[name='" + uom + "_ndc10_format']").val();
                var ndc11 = $("input[name='" + uom + "_ndc']");
                ndc11.val("");
                var ndc11_val = "";
                if (ndc10.length && ndc10_format.length) {
                    ndc11_val = abcsetup.rx_item.workflow.ndc10_to_ndc11(ndc10, ndc10_format);
                    ndc11.val(ndc11_val);
                    console.log(uom + ': ndc10[' + ndc10 + ']->ndc11[' + ndc11_val + ']');
                }

            }).trigger("change");

        });

        /*
        * Wholesale unit and PO Identifier changes
        */
        var wholesale_unit_select = $("#wholesale_unit");
        var po_id_select = $("#po_id");

        var uom_codes = {};
        if (($("#type").val() === 'otg' && init_class == 'bluepoint_cm') || $("#legend_device").val() != 'Y') {
            uom_codes = {
                "NDC": "NDC",
                "UPC": "UPC",
                "VC": "VC",
                "GTIN": "GTIN",
            };
        }
        else {
            uom_codes = {
                "NDC": "NDC",
            };
        }

        var po_id_options = {
            CS: {"": "-select-"},
            PK: {"": "-select-"},
            EA: {"": "-select-"},

        };

        $.each(['CS','PK','EA'], function(uom_idx,uom_val) {
            $.each(uom_codes, function(code_idx,code_val) {
                var t = uom_val+" "+code_idx;
                if (uom_val == "CS" || uom_val == "PK" || uom_val == "EA") {
                    po_id_options["CS"][t] = uom_val+" "+code_val;
                }
                if (uom_val == "PK" || uom_val == "EA") {
                    po_id_options["PK"][t] = uom_val+" "+code_val;
                }
                if (uom_val == "EA") {
                    po_id_options["EA"][t] = uom_val+" "+code_val;
                }
            });
        });

        wholesale_unit_select.change(function() {
            var wholesale_unit = $(this).val();
            // update po_id_select
            if (po_id_select.length) {
                abcsetup.rx_item.workflow._htmlSelectOptionsReplace({
                    select: po_id_select,
                    options: po_id_options[wholesale_unit],
                    selected: po_id,
                });
            }
        }).trigger("change");


        /*
        * CFR and IATA hazmat
        */
        var hazmat_fields = {
            cfr: [
                "product_regulated",
                "un_id",
                "hazard_class",
                "pack_group",
                "shipping_name_1",
                "label_code",
                "qty_limit_par",
                "qty_limit_cao",
                "vessel_stowage_location",
                "vessel_stowage_other",
            ],
            iata: [
                "product_regulated",
                "un_id",
                "shipping_name",
                "descr",
                "pack_group",
            ],
        };
        var hazmat_types = ['cfr', 'iata'];
        var hazmat_config = {
            change_field: function (args) {
                // args: hazmat_type, field, data_obj
                console.log("hazmat_config.change_field: args->" + JSON.stringify(args, {}, 4));
                hazmat_config[args.hazmat_type][args.field + "_select"].obj.empty();
                var list_length = Object.keys(args.data_obj).length;
                if (list_length > 1) {
                    hazmat_config[args.hazmat_type][args.field + "_select"].obj.append($("<option></option>").attr("value", "").text("-select-"));
                }
                Object.keys(args.data_obj).forEach(function (key) {
                    hazmat_config[args.hazmat_type][args.field + "_select"].obj.append($("<option></option>").attr("value", key).text(key));
                });
                if (list_length == 1) {
                    hazmat_config[args.hazmat_type][args.field + "_select"].obj.trigger("change");
                } else {
                    if (hazmat_config[args.hazmat_type][args.field + "_select"].obj.find("option[value='" + hazmat_config[args.hazmat_type][args.field + "_select"].val + "']").length) {
                        hazmat_config[args.hazmat_type][args.field + "_select"].obj.val(hazmat_config[args.hazmat_type][args.field + "_select"].val);
                        hazmat_config[args.hazmat_type][args.field + "_select"].obj.trigger("change");
                    }
                }
            }
        };

        hazmat_types.forEach(function (hazmat_type) {
            hazmat_config[hazmat_type] = {};
            // field objects
            hazmat_fields[hazmat_type].forEach(function (hazmat_field) {
                hazmat_config[hazmat_type][hazmat_field + "_select"] = {};
                hazmat_config[hazmat_type][hazmat_field + "_select"]["obj"] = $("#" + hazmat_field + "_" + hazmat_type);
                hazmat_config[hazmat_type][hazmat_field + "_select"]["val"] = "_undef_";
                if (abcsetup.item != undefined) {
                    if (abcsetup.item[hazmat_field + "_" + hazmat_type] != undefined) {
                        hazmat_config[hazmat_type][hazmat_field + "_select"]["val"] = abcsetup.item[hazmat_field + "_" + hazmat_type]
                    }
                }
            });
        });

        // add event handlers
        var abc_hazmat_obj = {};
        var selected_hazmat_fields = {};
        hazmat_types.forEach(function (hazmat_type) {
            selected_hazmat_fields[hazmat_type] = {};
            if (!hazmat_config[hazmat_type].un_id_select.obj.is(":disabled")) {
                if (hazmat_type == "cfr") {
                    console.log('hazmat event handlers: cfr', hazmat_config[hazmat_type].un_id_select.obj);
                    // un_id_select -> hazard_class_select
                    hazmat_config[hazmat_type].un_id_select.obj.change(function () {
                        console.log('hazmat event handlers: cfr: un_id change');
                        selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        $("#hazmat_id_" + hazmat_type).val("");
                        hazmat_fields[hazmat_type].forEach(function (hazmat_field) {
                            if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                                hazmat_config[hazmat_type][hazmat_field + "_select"].obj.empty().append($("<option></option>").attr("value", "").text("-select-"));
                            }
                        });
                        $.ajax({
                            type: "POST",
                            url: "/api/abc_item/hazmat_cfr_search",
                            cache: false,
                            dataType: 'json',
                            data: {un_id: un_id},
                            success: function (result) {
                                console.log("item/hazmat_cfr_search[hazard_class]: result->" + JSON.stringify(result, {}, 4));
                                if (!$.isEmptyObject(result)) {
                                    abc_hazmat_obj[hazmat_type] = result;
                                    hazmat_config.change_field({
                                        hazmat_type: hazmat_type,
                                        field: "hazard_class",
                                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"]
                                    });
                                }
                            }
                        });
                    });
                    // hazard_class_select -> pack_group_select
                    hazmat_config[hazmat_type].hazard_class_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["hazard_class"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        hazmat_config.change_field({
                            hazmat_type: hazmat_type,
                            field: "pack_group",
                            data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group']
                        });
                    });
                    // pack_group_select -> shipping_name_1_select
                    hazmat_config[hazmat_type].pack_group_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                        var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        hazmat_config.change_field({
                            hazmat_type: hazmat_type,
                            field: "shipping_name_1",
                            data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"]
                        });
                    });
                    // shipping_name_1_select -> label_code_select
                    hazmat_config[hazmat_type].shipping_name_1_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["shipping_name_1"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                        var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                        var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        hazmat_config.change_field({
                            hazmat_type: hazmat_type,
                            field: "label_code",
                            data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"]
                        });
                    });
                    // label_code_select -> qty_limit_par_select
                    hazmat_config[hazmat_type].label_code_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["label_code"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                        var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                        var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                        var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        hazmat_config.change_field({
                            hazmat_type: hazmat_type,
                            field: "qty_limit_par",
                            data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"]
                        });
                    });
                    // qty_limit_par_select -> qty_limit_cao_select
                    hazmat_config[hazmat_type].qty_limit_par_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["qty_limit_par"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                        var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                        var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                        var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                        var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        hazmat_config.change_field({
                            hazmat_type: hazmat_type,
                            field: "qty_limit_cao",
                            data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"]
                        });
                    });
                    // qty_limit_cao_select -> vessel_stowage_location_select
                    hazmat_config[hazmat_type].qty_limit_cao_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["qty_limit_cao"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                        var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                        var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                        var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                        var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                        var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        hazmat_config.change_field({
                            hazmat_type: hazmat_type,
                            field: "vessel_stowage_location",
                            data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"]
                        });
                    });
                    // vessel_stowage_location_select -> vessel_stowage_other_select
                    hazmat_config[hazmat_type].vessel_stowage_location_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["vessel_stowage_location"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                        var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                        var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                        var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                        var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                        var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                        var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        hazmat_config.change_field({
                            hazmat_type: hazmat_type,
                            field: "vessel_stowage_other",
                            data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"]
                        });
                    });
                    // vessel_stowage_other_select
                    hazmat_config[hazmat_type].vessel_stowage_other_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["vessel_stowage_other"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                        var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                        var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                        var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                        var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                        var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                        var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                        var vessel_stowage_other = selected_hazmat_fields[hazmat_type]["vessel_stowage_other"];
                        var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"][vessel_stowage_other]["hazmat_id"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        console.log("hazmat_id->" + hazmat_id);
                        $("#hazmat_id_" + hazmat_type).val(hazmat_id);
                    });
                    if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                        hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                    }
                } else if (hazmat_type == "iata") {
                    // un_id_select -> shipping_name_select
                    hazmat_config[hazmat_type].un_id_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        $("#hazmat_id_" + hazmat_type).val("");
                        hazmat_fields[hazmat_type].forEach(function (hazmat_field) {
                            if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                                hazmat_config[hazmat_type][hazmat_field + "_select"].obj.empty().append($("<option></option>").attr("value", "").text("-select-"));
                            }
                        });
                        $.ajax({
                            type: "POST",
                            url: "/api/abc_item/hazmat_iata_search",
                            cache: false,
                            dataType: 'json',
                            data: {un_id: un_id},
                            success: function (result) {
                                console.log("item/hazmat_iata_search[shipping_name]: result->" + JSON.stringify(result, {}, 4));
                                if (!$.isEmptyObject(result)) {
                                    abc_hazmat_obj[hazmat_type] = result;
                                    hazmat_config.change_field({
                                        hazmat_type: hazmat_type,
                                        field: "shipping_name",
                                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"]
                                    });
                                }
                            }
                        });
                    });
                    // shipping_name_select -> descr_select
                    hazmat_config[hazmat_type].shipping_name_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["shipping_name"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        hazmat_config.change_field({
                            hazmat_type: hazmat_type,
                            field: "descr",
                            data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr']
                        });
                    });
                    // descr_select -> pack_group_select
                    hazmat_config[hazmat_type].descr_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["descr"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                        var descr = selected_hazmat_fields[hazmat_type]["descr"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        hazmat_config.change_field({
                            hazmat_type: hazmat_type,
                            field: "pack_group",
                            data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"]
                        });
                    });
                    // pack_group_select
                    hazmat_config[hazmat_type].pack_group_select.obj.change(function () {
                        selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                        var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                        var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                        var descr = selected_hazmat_fields[hazmat_type]["descr"];
                        var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                        var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"][pack_group]["hazmat_id"];
                        console.log("selected_hazmat_fields->" + JSON.stringify(selected_hazmat_fields, {}, 4));
                        console.log("hazmat_id->" + hazmat_id);
                        $("#hazmat_id_" + hazmat_type).val(hazmat_id);
                    });
                    if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                        hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                    }
                }
            }
        });
    },

    ndc10_to_ndc11: function (ndc10, ndc10_format) {
        var ndc11 = "";
        switch (ndc10_format) {
            case "4-4-2":
                ndc11 = "0" + ndc10.replace(/\-/g, "");
                break;
            case "5-3-2":
                ndc11 = ndc10.substr(0, 5) + "0" + ndc10.substr(6, 3) + ndc10.substr(10, 2);
                break;
            case "5-4-1":
                ndc11 = ndc10.substr(0, 5) + ndc10.substr(6, 4) + "0" + ndc10.substr(11, 1);
                break;
        }
        console.log('ndc10_to_ndc11[' + ndc10_format + ']: [' + ndc10 + ']->[' + ndc11 + ']');
        return ndc11;
    },


    /**
     * Init the GTIN Grid
     */
    _initGTIN: function () {
        require('./_gtin_grid');
    },

    _initSAPDiv: function () {
        require('./_sap_divisions');
    },

    /**
     * Reject the item
     */
    _rejectItem: function () {
        let error = false;
        const checkedItems = $('.dropdown-menu.reject input:checkbox:checked');

        //Click to Reject item
        if (checkedItems.length == 0) {
            abcsetup.alerts.show('Reject Error', 'Please select at least 1 reason to reject the item');
            return false;
        }

        // Validate the rejection reasons
        checkedItems.each(function () {
            const rejectReasonField = $('textarea[name="reject_reason_text[' + $(this).attr('value') + ']"].required');
            if (rejectReasonField.length > 0 && !rejectReasonField.val()) {
                error = true;
                rejectReasonField.addClass('error');
            }
        });

        if (error) {
            return false;
        }

        $('#reject-btn').unbind('click').attr('type', 'submit').trigger('click');
    },

    _htmlSelectOptionsReplace: function (args) {
        // args: select, options, selected

        if (!args.select) {
            return;
        }

        const selected = args.selected || "";
        args.select.children('option').remove();

        for (const value in args.options) {
            if (!args.options.hasOwnProperty(value)) {
                continue;
            }

            const option = $('<option/>', {value, text: args.options[value]});

            if (value && selected == value) {
                option.attr('selected', true);
            }

            option.appendTo(args.select);
        }
    },
}
